export default __webpack_public_path__ + "languages/ru.21882a83.pathmapping.json";